import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import ProfileSection from './components/ProfileSection';

const AccountSettings = () => {
  const navigate = useNavigate();
  
  const breadcrumbItems = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Account Settings', path: '/account-settings' }
  ];

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <div className="fixed inset-0 -z-10 bg-[url('/assets/images/medical.jpg')] bg-cover bg-center bg-no-repeat" />
      <div className="fixed inset-0 -z-10 bg-black/75" />

      <div className="relative z-10 min-h-screen overflow-y-auto pb-24">
        <Header />

        <div className="pt-10 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <Breadcrumb items={breadcrumbItems} />
              <div className="text-center">
                <h1 className="text-3xl font-light text-white tracking-tight">Account Settings</h1>
                <p className="mt-2 text-slate-300 max-w-2xl mx-auto">
                  Manage your account information and preferences.
                </p>
              </div>
            </div>

            {/* Profile Information Card */}
            <div className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-2xl shadow-xl">
              <div className="border-b border-white/10 px-6 py-4">
                <h2 className="text-lg font-medium text-white flex items-center">
                  <div className="w-6 h-6 bg-blue-500/20 rounded-lg flex items-center justify-center mr-3">
                    <div className="w-3 h-3 bg-blue-400 rounded-sm opacity-80"></div>
                  </div>
                  Profile Information
                </h2>
                <p className="mt-1 text-sm text-slate-300">
                  Update your personal information and preferences
                </p>
              </div>
              <div className="px-6 py-6">
                <ProfileSection />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSettings;